import api from "../../utils/apiUserTienda";

export const getUsuarios = async (page = 1, limit = 20, usuario = "", correo = "") => {
  try {
    const res = await api.get("/api/tienda/usuarios/obtener", {
      params: { page, limit, usuario, correo },
    });

    return res.data;
  } catch (err) {
    console.error("Error al obtener usuarios:", err);
    throw err;
  }
};

export const crearUsuario = async (usuarioData) => {
  const res = await api.post("/api/tienda/usuarios/crear", usuarioData);
  return res.data;
};

export const updateUser = async (id, data) => {
  const res = await api.put(`/api/tienda/usuarios/actualizar/${id}`, data);
  return res.data;
};

// Reenvía la invitación a un usuario en estado pendiente (invalida la anterior).
export const reenviarInvitacion = async (id) => {
  const res = await api.post(`/api/tienda/usuarios/${id}/reenviar-invitacion`);
  return res.data;
};

// Envía un enlace de restablecimiento de contraseña a un usuario activo.
export const enviarResetUsuario = async (id) => {
  const res = await api.post(`/api/tienda/usuarios/${id}/enviar-reset`);
  return res.data;
};
